export enum CurrentJobEnum {
  NO = "no",
  YES = "yes",
}
